export const requestToPromise = <T>(request: IDBRequest<T>): Promise<T> => {
	return new Promise((resolve, reject) => {
		request.onsuccess = () => resolve(request.result);
		request.onerror = () => reject(request.error);
	});
};

export const collectCursorValues = <T>(
	requestFactory: () => IDBRequest<IDBCursorWithValue | null>,
	limit?: number
): Promise<T[]> => {
	return new Promise<T[]>((resolve, reject) => {
		const results: T[] = [];
		const request = requestFactory();

		request.onsuccess = () => {
			const cursor = request.result;
			if (!cursor) {
				resolve(results);
				return;
			}
			results.push(cursor.value as T);
			if (limit && results.length >= limit) {
				resolve(results);
				return;
			}
			cursor.continue();
		};

		request.onerror = () => reject(request.error);
	});
};
